import React, {useEffect} from 'react';
import {YouTube4VideoJsPlayer} from '../components/YouTube4VideoJsPlayer';
import * as MaterialUI from "@material-ui/core";
import * as MaterialUIIcon from "@material-ui/icons";
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import i18next from "../i18n/i18n";
import {VideoJsPlayer} from "../components/VideoJsPlayer";
import {useStores} from "../hooks/useStores";
import {observer, useObserver} from "mobx-react";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        width: 100,
        height: 100,
        [theme.breakpoints.down("xs")]: {
            width: 100,
            height: 100,
        },
        [theme.breakpoints.down("md")]: {
            width: 80,
            height: 80,
        },
        [theme.breakpoints.down("sm")]: {
            width: 40,
            height: 40,
        },
        backgroundSize: 'contain',
        backgroundImage:
            "url(\"data:image/svg+xml;base64,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\")",

    },
    checkedIcon: {
        width: 100,
        height: 100,
        [theme.breakpoints.down("xs")]: {
            width: 100,
            height: 100,
        },
        [theme.breakpoints.down("md")]: {
            width: 80,
            height: 80,
        },
        [theme.breakpoints.down("sm")]: {
            width: 40,
            height: 40,
        },
        backgroundSize: 'contain',
        backgroundImage:
            "url(\"data:image/svg+xml;utf8;base64,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\")",
    },
    gridListRoot: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflowX: 'hidden',
        overflowY: 'hidden',
        overflowScrolling: "touch",
        WebkitOverflowScrolling: "touch",
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        [theme.breakpoints.up('xl')]: { //1920
            width: 1344,
            height: 510,
        },
        [theme.breakpoints.down('lg')]: { //960
            width: 1200,
            height: 510,
        },
        [theme.breakpoints.down('md')]: { //960
            width: 740,
            height: 270,
        },

        [theme.breakpoints.down('sm')]: { //960
            width: 550,
            height: 410,
        },
        [theme.breakpoints.down('xs')]: { //600
            width: 360,
            height: 290,
        },
    },
    lockIcon: {
        zIndex:99,
        position: 'absolute',
        bottom: 0,
        right: 0,
    },
    lockBg: {
        zIndex:98,
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255,255,255,0.5)',
        width: '100%',
        height: '100%'
    },
}));

const style = {
    dayContainer: {
        zIndex: 11,
        overflowX: 'hidden',
        overflowY: 'hidden',
        overflowScrolling: "touch",
        WebkitOverflowScrolling: "touch",
        backgroundImage: `url(./img/dayWallpaper.jpg)`,
        backgroundSize: 'contain',
        padding: 0
    },
    nightContainer: {
        zIndex: 11,
        overflowX: 'hidden',
        overflowY: 'hidden',
        overflowScrolling: "touch",
        WebkitOverflowScrolling: "touch",
        backgroundImage: `url(./img/nightWallpaper.jpg)`,
        backgroundSize: 'contain',
        padding: 0
    },
}

export const BabyShark = observer(() => {
    const classes = useStyles();
    const { commonStore } = useStores();
    const [checked, setChecked] = React.useState(false);
    const [currentBg, setCurrentBg] = React.useState(style.dayContainer);
    const [open, setOpen] = React.useState(false);
    const [locale, setLocale] = React.useState('en');
    const {t} = useTranslation();

    const videoJsOptions = {
        autoplay: false,
        controls: true,
        preload: 'auto',
        muted: true,
        playsInline: true,
        fluid: false,
        fullscreen: true,
        responsive: true,
        textTrackSettings: false,
        aspectRatio: '16:9',
        controlBar: {
            volumePanel: {
                inline: false,
                volumeControl: {
                    vertical: true
                }
            }
        },
        sources: [{
            type: "application/x-mpegURL",
            src: process.env.REACT_APP_BROADCAST_STREAM_URL
        }],
    }

    const toggleVideoPlay = (event) => {
       let player = window.videojs('video-js');
       if (event.target.checked) {
           player.play();
           setChecked(true);
           setCurrentBg(style.nightContainer);
       } else {
           player.pause();
           setChecked(false);
           setCurrentBg(style.dayContainer);
       }
        player.on('ended', function() {
            setChecked(false);
            setCurrentBg(style.dayContainer);
        });
    }

    const gridListData = [
        { img: 'https://img.youtube.com/vi/XqZsoesa55w/hqdefault.jpg', link: 'https://youtu.be/XqZsoesa55w', title: 'Image', author: 'author', lock: false},
        { img: 'https://img.youtube.com/vi/xxIpqTkFYrU/hqdefault.jpg', link: 'https://youtu.be/xxIpqTkFYrU', title: 'Image', author: 'author', lock: false},
        { img: 'https://img.youtube.com/vi/IxaXsFPTU10/hqdefault.jpg', link: 'https://youtu.be/IxaXsFPTU10', title: 'Image', author: 'author', lock: false},
        { img: 'https://img.youtube.com/vi/oUcOwKqrb9s/hqdefault.jpg', link: 'https://youtu.be/oUcOwKqrb9s', title: 'Image', author: 'author', lock: false},
        { img: 'https://img.youtube.com/vi/GR2o6k8aPlI/hqdefault.jpg', link: 'https://youtu.be/GR2o6k8aPlI', title: 'Image', author: 'author', lock: true},
        { img: 'https://img.youtube.com/vi/ltiYn2blsuQ/hqdefault.jpg', link: 'https://youtu.be/ltiYn2blsuQ', title: 'Image', author: 'author', lock: true},
    ];
    const theme = useTheme();
    const screenExtraLarge = useMediaQuery(theme.breakpoints.only('xl'));
    const screenLarge = useMediaQuery(theme.breakpoints.only('lg'));
    const screenMedium = useMediaQuery(theme.breakpoints.only('md'));
    const screenSmall = useMediaQuery(theme.breakpoints.only('sm'));
    const screenExtraSmall = useMediaQuery(theme.breakpoints.only('xs'));
    const screenNarrow = useMediaQuery('(max-width:340px)');

    const getScreenWidth = () => {
        if (screenExtraLarge) {
            return 3;
        } else if (screenNarrow) {
            return 3;
        } else if (screenLarge) {
            return 3;
        } else if (screenMedium) {
            return 3;
        } else if (screenSmall) {
            return 2;
        } else if (screenExtraSmall) {
            return 2;
        } else {
            return 3;
        }
    }

    const getCellHeight = () => {
        if (screenExtraLarge) {
            return 250;
        } else if (screenNarrow) {
            return 250;
        } else if (screenLarge) {
            return 220;
        } else if (screenMedium) {
            return 130;
        } else if (screenSmall) {
            return 130;
        } else if (screenExtraSmall) {
            return 90;
        } else {
            return 3;
        }
    }

    const handleSelectedPlay = (event) => {
        if (event.currentTarget.dataset.lock === 'true' && commonStore.logged === false) {
            setOpen(true);
            return null;
        }
        // TODO: 타입에 따라 처리 방식을 달리 해야함.
        // 액티비티는 상세 페이지로 가고
        // 이미지는 링크던 뭐던 이동 해야 하고
        // 샾도 상세 페이지로 가고
        setChecked(false);
        setCurrentBg(style.dayContainer);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(()=>{
        commonStore.setDetailMode(false);
    },[])

    return useObserver( () =>
        <>
        <MaterialUI.Container maxWidth={"xl"} style={currentBg}>
            <MaterialUI.Box display="flex" justifyContent="center" mt={8} mb={8} p={0}>
                <MaterialUI.Box p={0} width={"15%"}>
                </MaterialUI.Box>
                <MaterialUI.Box p={0} width={"70%"}>
                    <VideoJsPlayer {...videoJsOptions} showCustomButton={true} forcePlay={false}/>
                </MaterialUI.Box>
                <MaterialUI.Box p={0} width={"15%"}>
                    <MaterialUI.Checkbox
                        checked={checked}
                        onChange={toggleVideoPlay}
                        className={classes.root}
                        disableRipple
                        color="default"
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }} />
                </MaterialUI.Box>
            </MaterialUI.Box>
        </MaterialUI.Container>
        <MaterialUI.Box m={3}>
            <div className={classes.gridListRoot}>
                <MaterialUI.GridList cols={getScreenWidth()} cellHeight={getCellHeight()} className={classes.gridList}>
                    { gridListData.map((tile) => (
                        <MaterialUI.GridListTile key={tile.link} data-img={tile.img} data-link={tile.link} data-lock={tile.lock} onClick={handleSelectedPlay}>
                            {tile.lock && commonStore.logged === false ? <div className={classes.lockBg}>
                                <MaterialUI.GridListTileBar
                                    title={t('requiredSignIn')}
                                    subtitle={<span>{t('requiredSignInMessage')}</span>}
                                    actionIcon={
                                        <MaterialUI.IconButton>
                                            <MaterialUIIcon.Lock style={{color:'white'}}/>
                                        </MaterialUI.IconButton>
                                    }
                                />
                            </div> : ""}
                            <img src={tile.img} alt={tile.title} />
                        </MaterialUI.GridListTile>
                    ))}
                </MaterialUI.GridList>
            </div>
        </MaterialUI.Box>
        <MaterialUI.Box m={3}>
            <div className={classes.gridListRoot}>
                <MaterialUI.GridList cols={getScreenWidth()} cellHeight={getCellHeight()} className={classes.gridList}>
                    { gridListData.map((tile) => (
                        <MaterialUI.GridListTile key={tile.link} data-img={tile.img} data-link={tile.link} data-lock={tile.lock} onClick={handleSelectedPlay}>
                            {tile.lock && commonStore.logged === false ? <div className={classes.lockBg}>
                                <MaterialUI.GridListTileBar
                                    title={t('requiredSignIn')}
                                    subtitle={<span>{t('requiredSignInMessage')}</span>}
                                    actionIcon={
                                        <MaterialUI.IconButton>
                                            <MaterialUIIcon.Lock style={{color:'white'}}/>
                                        </MaterialUI.IconButton>
                                    }
                                />
                            </div> : ""}
                            <img src={tile.img} alt={tile.title} />
                        </MaterialUI.GridListTile>
                    ))}
                </MaterialUI.GridList>
            </div>
        </MaterialUI.Box>
        <MaterialUI.Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <MaterialUI.DialogTitle id="alert-dialog-title">{t('requiredSignInModal')}</MaterialUI.DialogTitle>
            <MaterialUI.DialogContent>
                <MaterialUI.DialogContentText id="alert-dialog-description">
                    {t('requiredSignInMessageModal')}
                </MaterialUI.DialogContentText>
            </MaterialUI.DialogContent>
            <MaterialUI.DialogActions>
                <MaterialUI.Button onClick={handleClose} color="primary">
                    {t('disagreeButton')}
                </MaterialUI.Button>
                <MaterialUI.Button onClick={handleClose} color="primary" autoFocus>
                    {t('agreeButton')}
                </MaterialUI.Button>
            </MaterialUI.DialogActions>
        </MaterialUI.Dialog>
        </>
    );
})
